import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { vacationsApi } from 'app/services/edpApiV1/vacations';
import { consultationsApi, ConsultationsResponse } from 'app/services/edpApiV1/consultations';
import { TConsultationsInfo } from 'shared/types/consultations.types';

type Consultations = {
  data: TConsultationsInfo[] | null;
  pagination: {
    size?: number;
    page?: number;
    total: number;
  } | null;
};

const initialState: Consultations = {
  data: null,
  pagination: null,
};

export const consultationsSlice = createSlice({
  name: 'consultations',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addMatcher(
        consultationsApi.endpoints.consultations.matchFulfilled,
        (_, { payload }: PayloadAction<ConsultationsResponse>) => payload,
      )
      .addMatcher(vacationsApi.endpoints.vacations.matchRejected, () => initialState);
  },
});

const consultations = (state: RootState) => state.entities.consultations;
const getConsultations = createSelector(consultations, state => state);

export const selectors = { getConsultations };
export const actions = consultationsSlice.actions;
export const reducer = consultationsSlice.reducer;
